



















































import { Component, Vue, Prop } from "vue-property-decorator";
import ChatModel from "@/models/Chat";
import { getModule } from "vuex-module-decorators";
import { store, UserModule } from "@/store";
import firebase from "firebase";
import moment from "moment";
import _debug from "debug";

class ChatModelView {
    constructor(public chatModel: ChatModel, public podeVisualizar: boolean) {}
}
const debug = _debug("Mediacao:ChatList.vue");

const userModule = getModule(UserModule, store);

@Component({
    components: {},
})
export default class ChatsList extends Vue {
    @Prop() public carregando!: boolean;
    @Prop() public chats!: ChatModel[];
    @Prop() public podeAdicionar!: boolean;
    @Prop({ default: true }) public podeVisualizar!: boolean;
    @Prop() public poderApagar!: boolean;
    @Prop({ default: "chats" }) public titulo!: string;
    @Prop({ default: false }) public mostraTopo!: boolean;

    private chatModelViews: ChatModelView[] = [];

    public adiciona() {
        debug("adicionando...");
        this.$emit("adicionarchat");
    }

    public visualizarChat(chat: ChatModel) {
        this.$emit("visualizarChat", chat);
    }

    public apagarChat(chat: ChatModel) {
        debug("Apagar chat no filho");
        this.$emit("apagarChat", chat);
    }

    private async created() {
        debug("ChatList.created, chats:", this.chats);
        const user = await userModule.getUser;
        this.chatModelViews = this.chats.map(chat => {
            let podeVisualizar = this.podeVisualizar;
            if (chat.status !== "aberto") {
                podeVisualizar = user.hasRoleOf(["admin", "mediador"]);
            }
            const chatModelView = new ChatModelView(chat, podeVisualizar);
            return chatModelView;
        });
        debug("ChatList.created: chatModelViews", this.chatModelViews);
    }

    private formatData(data: firebase.firestore.Timestamp | Date) {
        debug("data:", data, moment(new Date()).format("DD/MM/YYYY"));
        if (data instanceof Date) {
            return moment(data).format("DD/MM/YYYY HH:mm");
        } else {
            return moment(data.toDate()).format("DD/MM/YYYY HH:mm");
        }
    }
}
